/* Tylavitt · Home — interações das seções bb-
   (abas e ordem dos produtos, antes/depois arrastável, copiar cupom).
   Pode ser incluído por várias seções: só roda uma vez. */
(function () {
  if (window.__bbIniciado) return;
  window.__bbIniciado = true;

  function iniciar(raiz) {
    raiz = raiz || document;

    /* ---------- copiar cupom ---------- */
    raiz.querySelectorAll('[data-bb-copiar]').forEach(function (btn) {
      if (btn.__bb) return;
      btn.__bb = true;
      btn.addEventListener('click', function () {
        var codigo = btn.getAttribute('data-bb-copiar');
        var original = btn.textContent;
        var feito = function () {
          btn.textContent = 'copiado!';
          setTimeout(function () { btn.textContent = original; }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(feito, feito);
        } else {
          var t = document.createElement('textarea');
          t.value = codigo;
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); } catch (e) {}
          t.remove();
          feito();
        }
      });
    });

    /* ---------- produtos: abas, ordem e modo de exibição ---------- */
    raiz.querySelectorAll('[data-bb-produtos]').forEach(function (sec) {
      if (sec.__bb) return;
      sec.__bb = true;
      var abas = sec.querySelectorAll('[data-bb-aba]');
      var paineis = sec.querySelectorAll('[data-bb-painel]');
      var ordem = sec.querySelector('[data-bb-ordem]');
      var modos = sec.querySelectorAll('[data-bb-modo]');

      function ordenar(painel) {
        if (!ordem || !painel) return;
        var tipo = ordem.value;
        var cards = Array.prototype.slice.call(painel.querySelectorAll('.bb-card'));
        cards.sort(function (a, b) {
          var pa = +a.dataset.preco, pb = +b.dataset.preco;
          if (tipo === 'menor') return pa - pb;
          if (tipo === 'maior') return pb - pa;
          if (tipo === 'nota') return (+b.dataset.nota) - (+a.dataset.nota);
          return (+a.dataset.ordem) - (+b.dataset.ordem);
        });
        cards.forEach(function (c) { painel.appendChild(c); });
      }

      abas.forEach(function (aba) {
        aba.addEventListener('click', function () {
          var alvo = aba.getAttribute('data-bb-aba');
          abas.forEach(function (a) {
            var ativa = a === aba;
            a.classList.toggle('is-ativa', ativa);
            a.setAttribute('aria-selected', ativa ? 'true' : 'false');
          });
          paineis.forEach(function (p) {
            var mostra = p.getAttribute('data-bb-painel') === alvo;
            p.hidden = !mostra;
            if (mostra) ordenar(p);
          });
        });
      });

      if (ordem) {
        ordem.addEventListener('change', function () {
          paineis.forEach(function (p) { if (!p.hidden) ordenar(p); });
        });
      }

      modos.forEach(function (b) {
        b.addEventListener('click', function () {
          var lista = b.getAttribute('data-bb-modo') === 'lista';
          sec.classList.toggle('bb-prod--lista', lista);
          modos.forEach(function (x) {
            var ativo = x === b;
            x.classList.toggle('is-ativo', ativo);
            x.setAttribute('aria-pressed', ativo ? 'true' : 'false');
          });
        });
      });
    });

    /* ---------- antes e depois arrastável ---------- */
    raiz.querySelectorAll('[data-bb-compara]').forEach(function (box) {
      if (box.__bb) return;
      box.__bb = true;
      var range = box.querySelector('input[type="range"]');
      var arrastando = false;

      function definir(pct) {
        pct = Math.max(0, Math.min(100, pct));
        box.style.setProperty('--pos', pct + '%');
        if (range) range.value = Math.round(pct);
      }

      function pelaPosicao(x) {
        var r = box.getBoundingClientRect();
        definir(((x - r.left) / r.width) * 100);
      }

      box.addEventListener('pointerdown', function (e) {
        if (e.target.closest('a, button')) return;
        arrastando = true;
        box.classList.add('is-arrastando');
        if (box.setPointerCapture) box.setPointerCapture(e.pointerId);
        pelaPosicao(e.clientX);
      });
      box.addEventListener('pointermove', function (e) {
        if (arrastando) pelaPosicao(e.clientX);
      });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) {
        box.addEventListener(ev, function () {
          arrastando = false;
          box.classList.remove('is-arrastando');
        });
      });
      if (range) {
        range.addEventListener('input', function () { definir(+range.value); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(); });
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
